import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import Template from '../../Contexts/Template';
import { dispatchSkyfireMethods } from '../../utils';
import ImageRow from './items/ImageRow';
import InfiniteList from './items/InfiniteList';
export default function VisualTableWidget(props) {
    var _a, _b, _c;
    const dispatch = useDispatch();
    const template = useContext(Template);
    const { onTrackReorder } = props.data;
    const handleReorder = (moveToIndex, trackIndex) => {
        sessionStorage.setItem('moveTrackIndex', trackIndex);
        sessionStorage.setItem('dropIndex', moveToIndex);
        dispatch({ type: 'REORDER_TRACK', payload: { trackIndex, moveToIndex, isVisualPlayQueue: !!props.isVisualPlayQueue } });
        dispatchSkyfireMethods(dispatch, template, onTrackReorder);
    };
    return (React.createElement(InfiniteList, { data: props.data, handleSelected: props.handleSelected, handleReorder: ((_a = onTrackReorder) === null || _a === void 0 ? void 0 : _a.length) > 0 ? handleReorder : undefined, componentType: ImageRow, rowHeight: 80, loading: (_b = props) === null || _b === void 0 ? void 0 : _b.loading, isVisualPlayQueue: (_c = props) === null || _c === void 0 ? void 0 : _c.isVisualPlayQueue }));
}
